export const getDocType = (documentTypeId) => {
  switch (documentTypeId) {
    case 'OS1': return 'Loan Files'
    case 'OS2': return 'QC Information'
    case 'OS3': return 'Marketing Materials'
    case 'OS4': return 'Questionnaire'
    case 'OS5': return 'Underwriter Information'
    case 'OS6': return 'Company Information'
    case 'OS7': return 'RLC Data'
    case 'OS8': return 'Other'
    default: return ''
  }
}

export const getAuditType = (auditTypeCode) => {
  switch (auditTypeCode) {
    case 'L': return 'Loan Origination'
    case 'S': return 'Servicing'
    case 'O': return 'OIG Inquiry'
    case 'R': return 'Other'
    default: return ''
  }
}

export const getAuditUnit = (auditingUnitCode) => auditingUnitCode === 'M' ? 'Monitoring Unit' : 'Quality Assurance'

export const getAuditLocation = (auditLocationCode) => auditLocationCode === 'T' ? 'Travel' : 'Virtual'